import { useMutation } from '@tanstack/react-query'
import { commonApi } from '../../api'

function useGenerateClientToken() {
  return useMutation({
    mutationKey: ['generate-client-token'],
    mutationFn: ({ code, cardId }) => commonApi.getPaymentCardClientToken(code, cardId),
  })
}

export default useGenerateClientToken
